module.exports = __webpack_public_path__ + "media/sns/btnLWA_gold_312x64-0fa0af59.png";